import { render } from "./RelespelhoPonto.vue?vue&type=template&id=1703484e"
import script from "./RelespelhoPonto.vue?vue&type=script&lang=js"
export * from "./RelespelhoPonto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__